import React, { useRef, useState, RefObject } from 'react';
import {
    ActType,
    IMultiCapabilityTemplateInfo,
    ITemplateComponentProps,
    TemplateType,
    VIEW_MODE,
    QuestionType,
    PanelType,
} from '../../../interface/multiCapabilityTemplate';
import { Button, Modal, UmuInput } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { TemplateInfo } from '../../../components/templateInfo';
import { saveTemplateQuestionListByType } from '../../../server/template';
const defaultTemplateInfo: any = {
    desc: '',
    index: 1,
    paragraph_num: 0,
    question_num: 0,
    title: '',
    parent_type: TemplateType.MY,
    list: [
        {
            index: 1,
            extend: {
                resource_arr: [],
                setup: {
                    require: '1',
                },
            },
            type: QuestionType.RADIO,
            title: '',
            list: [
                {
                    index: 1,
                    extend: {
                        resource_arr: [],
                        setup: {
                            require: '1',
                        },
                    },
                    type: 0,
                    title: '',
                },
            ],
        },
    ],
};
const { confirm } = Modal;
const BodyContent = (props: ITemplateComponentProps) => {
    const { onCommunication } = props;
    const [isValid, setIsValid] = useState(false);
    const templateRef: RefObject<HTMLElement> = useRef(null);
    const [templateInfo, setTemplateInfo] = useState<any>(defaultTemplateInfo);
    const onDataChange = (data: IMultiCapabilityTemplateInfo) => {
        setTemplateInfo(data);
    };
    const onCheckData = () => {
        setIsValid(true);

        // 页面渲染完成后 获取 templateRef 下是否有 valid-text 样式元素，有则返回false 并滚动到第一个valid-text 到可视区域
        return new Promise((resolve) => {
            requestAnimationFrame(() => {
                if (templateRef.current) {
                    const validTextElement = templateRef.current.querySelector('.valid-text');
                    if (validTextElement) {
                        validTextElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        return resolve(false); // 返回 false
                    }
                }
                resolve(true);
            });
        });
    };
    const renderContent = () => {
        return (
            <div className="template-info-editor-zone small-rows">
                <TemplateInfo
                    tmpRef={templateRef}
                    info={templateInfo}
                    isValid={isValid}
                    mode={VIEW_MODE.EDIT}
                    onChange={onDataChange}
                />
            </div>
        );
    };
    const onSaveTemplate = async () => {
        const isAccess = await onCheckData();
        if (!isAccess) {
            return;
        }
        const inputProps: any = {
            defaultValue: templateInfo.title,
            expandConfig: { placeholder: lang('请输入模板名称') },
            onChange: (e: any) => {
                const value = e.value;
                dialog.update({
                    okButtonProps: {
                        disabled: !value,
                    },
                });
                templateInfo.title = value;
            },
        };
        const dialog = confirm({
            title: lang('另存为模板'),
            centered: true,
            content: <UmuInput {...inputProps} />,
            okText: lang('确认'),
            okButtonProps: {
                disabled: (templateInfo?.title || '').length === 0,
            },
            cancelText: lang('取消'),
            onOk() {
                saveTemplateQuestionListByType({
                    parent_type: TemplateType.MY,
                    data: JSON.stringify(templateInfo),
                }).then((res) => {
                    if (res?.isSuccess) {
                        onCommunication(ActType.UPDATE_PANEL_TYPE, {
                            isReloadList: true,
                            info: {
                                panelType: PanelType.LIST,
                                isShowBack: false,
                            },
                        });
                    }
                });
            },
        });
    };
    const onSubmitClick = async () => {
        const isAccess = await onCheckData();
        if (!isAccess) {
            return;
        }
        onCommunication(ActType.PANEL_SUBMIT, {
            templateInfo: {
                parent_type: TemplateType.MY,
                templateInfo,
            },
        });
    };
    return (
        <div className="template-info-detail">
            {renderContent()}
            <div className="footer-list capability-flex-col fix-right">
                <Button type="ghost-grey" onClick={onSaveTemplate}>
                    {lang('另存为模板')}
                </Button>
                <Button type="primary" className="btn-split" onClick={onSubmitClick}>
                    {lang('使用_Save')}
                </Button>
            </div>
        </div>
    );
};

export const templateAdd = {
    BodyContent,
};
